import { Button, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Add, KeyboardArrowRight } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import FilterListIcon from "@material-ui/icons/FilterList";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PrintIcon from "@material-ui/icons/Print";
import SyncIcon from "@material-ui/icons/Sync";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { REGISTER_SERVICE_SIGNLE } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  getDepartmentsUser,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleTechician,
  isSalesConsultant,
  transformDate,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
import ChangeTreatmentPlanPopup from "../Popup/ChangeTreatmentPlanPopup";
import HistoryTreatmentPopup from "../Popup/HistoryTreatmentPopup";
import RegisterTreatmentPlanPopupTotalItem from "../Popup/RegisterTreatmentPlanPopupTotalItem";
import PrintPopupTreamentPlanTab from "../PrintTreatmentPlanTab/PrintPopupTreamentPlanTab";
import ListRegisterTreatmentPlan from "./ListRegisterTreatmentPlan";
import SearchRegisterTreatmentPlan from "./SearchRegisterTreatmentPlan";
import VoucherDepositDeductionPopup from "../../VoucherOrderDepositDeduction/VoucherDepositDeductionPopup";

const RegisterTreatmentPlanIndex = ({ values }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  let [open, setOpen] = useState(true);
  let [isOpenFillter, setOpenFillter] = useState(true);
  const defaultDepartment = useDefaultDepartment();
  const departmentsUser = getDepartmentsUser();
  const {
    searchRegisterTreatmentPlan,
    handleChangeFormSearchTreatmentPlan,
    openCreateOrEditTreatmentPlanPopup,
    handleOpenCreateOrEditTreatmentPlanPopup,
    handleCloseCreateOrEditServicePopup,
    saveOrUpdateRegisterService,
    initRegisterTreatmentPlan,
    openConfirmDelete,
    handleDeleteTreatmentPlanCard,
    handleOpenConfirmDelete,
    handleOpenPopupTreatmentPlan,
    openPopupPrintTreatmentPlan,
    handleClosePrintTreatmentPlan,
    selectedTreatmentPlan,
    pageRegisterTreatmentPlan,
    setSelectedRowTreatmentPlan,
    openChangeTreatmentPlanPopup,
    handleCloseChangeTreatmentPlanPopup,
    initChangeTreatmentPlan,
    handleChangeTreatment,
    resetStore,
    handleInitPaymentVoucherPopup,
    pagingRegisterTreatmentPlan,
    pagingRegisterTreatmentPlanItem,
    openConfirmDeleteMessage,
    handleCloseDeleteConfirmMessage,
    openConfirmUnlock,
    handleCloseConfirmUnlock,
    handleConfirmUnlock,
    treatmentFree,
    openConfirmLock,
    handleCloseConfirmLock,
    handleConfirmLock,
    openConfirmError,
    handleOpenConfirmError,
    handleCloseHistoryTreatmentPopup,
    openHistoryTreatmentPopup,
    searchDataHistory,
    pageDataHistory,
    handleChangeFormSearchHistory,
    handleOpenAddTreatmentPlanAdvicePopup,
    getTreatmentTimesOfServices,
    openPopupComfirms,
    responseDetailFormChangeTreament,
    handleClosePopupCofirmTrement,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;

  const {
    listStk,
    getListPaymentMethod,
    listPaymentMethod,
    getListProperties,
  } = useStore().feeStore.serviceFeeTabStore;
  const {
    listVatPercent,
    initialPatient,
    customerSourceWalkIn,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;
  let isAdminPermission = isAdmin();
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchTreatmentPlan({
        ...searchRegisterTreatmentPlan,
        patientId,
        getServices: true,
        fromDate: null,
        toDate: null,
      });
      getListPaymentMethod();
      let departmentIds = [];
      if (isAdminPermission) {
        departmentIds = defaultDepartment ? [defaultDepartment.id] : [];
      } else {
        departmentIds = departmentsUser?.length
          ? departmentsUser.map((d) => d.id)
          : defaultDepartment
            ? [defaultDepartment.id]
            : [];
      }
      getListProperties({ departmentIds });
    }
    return () => resetStore();
  }, [patientId]);

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isSalesConsultantPermission = isSalesConsultant();
  const isReadonly = isRoleHisReadOnly();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();

  const hasAddPermission =
    isAdmins ||
    isRoleCashierPermission ||
    isAccountant ||
    isRoleBranchManagerPermission;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorTreatmentPlanEl, setAnchorTreatmentPlanEl] = useState(null);
  return (
    <section className="form-patient " style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342", padding: "5px" }}>
        <div
          className="flex justify-between"
          style={{ fontSize: "16px", gap: "5px", fontWeight: "bold" }}
        >
          <p className="cards-header flex align-center item-form-header-custom">
            <span
              className="flex items-center pointer"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRight />}
              {REGISTER_SERVICE_SIGNLE ? 2 : 1}. Liệu trình
            </span>
            <span
              style={{ cursor: "pointer" }}
              className="flex items-center"
              onClick={() => setOpenFillter(!isOpenFillter)}
            >
              <FilterListIcon color="red" />
            </span>
          </p>
          <div className="flex gap-2">
            <div>
              {!isMobile && (
                <GlobitsDateTimePicker
                  name={"orderDate"}
                  label="Ngày tư vấn"
                  maxDateMessage="Ngày tư vấn phải trước ngày hiện tại"
                  maxDate={new Date()}
                // isDateTimePicker
                />
              )}
            </div>
            <div
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              {!isMobile && hasAddPermission && (
                <CommonButton
                  className="btn-add"
                  onClick={async (e) => {
                    setAnchorTreatmentPlanEl(
                      anchorTreatmentPlanEl ? null : e.target
                    );
                    setAnchorEl(null);
                  }}
                  style={{ position: "relative", height: "100%" }}
                >
                  <Add />
                  Liệu trình
                </CommonButton>
              )}

              {anchorTreatmentPlanEl && hasAddPermission && (
                <div
                  className="popover-list"
                  style={{
                    right: 0,
                    left: "auto",
                    position: "absolute",
                    minWidth: "160px",
                  }}
                >
                  <div
                    className="popover-item popover-item-custom"
                    style={{ color: "#4276a4" }}
                    onClick={() => {
                      handleOpenCreateOrEditTreatmentPlanPopup(
                        null,
                        initialPatient?.patientInfo,
                        customerSourceWalkIn,
                        defaultDepartment
                      );
                      setAnchorTreatmentPlanEl(null);
                    }}
                  >
                    <AddCircleOutlineIcon fontSize="small" className="icon" />
                    Thêm
                  </div>
                  <div
                    className="popover-item"
                    style={{ color: "#4276a4" }}
                    onClick={() => {
                      handleOpenAddTreatmentPlanAdvicePopup({
                        orderDate: values?.orderDate,
                        patientId,
                      });
                      setAnchorTreatmentPlanEl(null);
                    }}
                  >
                    <SyncIcon
                      fontSize="small"
                      color="#007b8f"
                      className="icon"
                    />
                    Lấy từ tư vấn
                  </div>
                </div>
              )}
            </div>
            {!isMobile && !isReadonly && (
              <Tooltip title={"In tất cả liệu trình"}>
                <Button
                  onClick={() => {
                    setSelectedRowTreatmentPlan(
                      (pageRegisterTreatmentPlan?.content || []).flat()
                    );
                    handleOpenPopupTreatmentPlan(true);
                  }}
                  style={{ backgroundColor: "#f16321", color: "white" }}
                >
                  <PrintIcon />
                  In phiếu
                </Button>
              </Tooltip>
            )}

            {hasAddPermission && (
              <CommonButton
                className="btn-add"
                onClick={() => {
                  handleOpenCreateOrEditTreatmentPlanPopup(
                    null,
                    initialPatient?.patientInfo,
                    customerSourceWalkIn,
                    defaultDepartment
                  );
                }}
              >
                <Add />
              </CommonButton>
            )}

            {isAdminPermission && (
              <CommonButton
                className="btn-add"
                onClick={() => getTreatmentTimesOfServices(patientId)}
              >
                <SyncAltIcon />
                Tính lại số lần điều trị
              </CommonButton>
            )}
          </div>
        </div>
        {open && (
          <Formik
            initialValues={searchRegisterTreatmentPlan}
            validationSchema={searchPatientValidationSchema}
            onSubmit={(values) => {
              handleChangeFormSearchTreatmentPlan(values);
            }}
            enableReinitialize
          >
            <Form autoComplete="off">
              {!isOpenFillter && (
                <>
                  <style>
                    {`
                      @keyframes slideDownFade {
                        0% {
                          opacity: 0;
                          transform: translateY(-10px);
                        }
                        100% {
                          opacity: 1;
                          transform: translateY(0);
                        }
                      }
                    `}
                  </style>
                  <div
                    style={{
                      animation: "slideDownFade 0.3s ease forwards",
                      zIndex: 10,
                      position: "relative",
                    }}
                  >
                    <SearchRegisterTreatmentPlan
                      pagingRegisterTreatmentPlanItem={
                        pagingRegisterTreatmentPlanItem
                      }
                    />
                  </div>
                </>
              )}
              <ListRegisterTreatmentPlan
                patient={initialPatient?.patientInfo}
                customerSourceWalkIn={customerSourceWalkIn}
              />
            </Form>
          </Formik>
        )}
        {!!openCreateOrEditTreatmentPlanPopup && (
          <RegisterTreatmentPlanPopupTotalItem
            open={!!openCreateOrEditTreatmentPlanPopup}
            handleClose={() => {
              handleCloseCreateOrEditServicePopup();
              pagingRegisterTreatmentPlan();
            }}
            onSubmit={saveOrUpdateRegisterService}
            initRegisterTreatmentPlan={{
              ...initRegisterTreatmentPlan,
              patientId,
            }}
            handleAfterSubmit={() =>
              handleGetPatientOverviewByIdNotLoading(patientId)
            }
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
            handleInitPaymentVoucherPopup={handleInitPaymentVoucherPopup}
            listPaymentMethod={listPaymentMethod}
            listStk={listStk}
            isAdminPermission={isAdminPermission}
            departmentsUser={departmentsUser}
          />
        )}

        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={() => handleOpenConfirmDelete(null)}
            text="Bạn có chắc chắn muốn hủy thẻ liệu trình này không ?"
            onConfirm={async () => {
              await handleDeleteTreatmentPlanCard();
              if (patientId) {
                await handleGetPatientOverviewByIdNotLoading(patientId);
              }
            }}
          />
        )}
        {!!openConfirmDeleteMessage && (
          <ConfirmPopup
            open={!!openConfirmDeleteMessage}
            onClose={() => handleCloseDeleteConfirmMessage(null)}
            text={openConfirmDeleteMessage}
            hideConfirm
            textClose={"Quay lại"}
            title="Thao tác thất bại"
          />
        )}

        {openPopupPrintTreatmentPlan && (
          <PrintPopupTreamentPlanTab
            open={openPopupPrintTreatmentPlan}
            handleClose={() => {
              handleClosePrintTreatmentPlan();
            }}
            pageRegisterTreatmentPlan={
              Array.isArray(selectedTreatmentPlan) &&
                selectedTreatmentPlan.length > 0
                ? selectedTreatmentPlan.flat()
                : (pageRegisterTreatmentPlan?.content || []).flat()
            }
            patient={initialPatient}
          />
        )}

        {!!openChangeTreatmentPlanPopup && (
          <ChangeTreatmentPlanPopup
            open={!!openChangeTreatmentPlanPopup}
            handleClose={handleCloseChangeTreatmentPlanPopup}
            initChangeTreatmentPlan={{
              ...initChangeTreatmentPlan,
              patientId,
            }}
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
            onSubmit={handleChangeTreatment}
            handleAfterSubmit={() =>
              handleGetPatientOverviewByIdNotLoading(patientId)
            }
            treatmentFree={treatmentFree}
          />
        )}
        {openConfirmUnlock && (
          <ConfirmPopup
            open={openConfirmUnlock}
            onClose={handleCloseConfirmUnlock}
            text="Bạn có muốn mở khóa liệu trình không ?"
            onConfirm={async () => {
              await handleConfirmUnlock();
              if (patientId) {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }
            }}
          />
        )}
        {openConfirmLock && (
          <ConfirmPopup
            open={openConfirmLock}
            onClose={handleCloseConfirmLock}
            text="Bạn có muốn khóa liệu trình không ?"
            onConfirm={async () => {
              await handleConfirmLock();
              if (patientId) {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }
            }}
          />
        )}
        {openConfirmError && (
          <ConfirmPopup
            open={openConfirmError}
            onClose={handleOpenConfirmError}
            text={openConfirmError}
            isNotAPromise
            hideConfirm
          />
        )}
        {openHistoryTreatmentPopup && (
          <HistoryTreatmentPopup
            open={openHistoryTreatmentPopup}
            handleClose={handleCloseHistoryTreatmentPopup}
            searchData={searchDataHistory}
            pageDataHistory={pageDataHistory}
            handleChangeFormSearch={handleChangeFormSearchHistory}
          />
        )}
        {!!openPopupComfirms && (
          <GlobitsConfirmationDialog
            maxWidth={"xs"}
            title="Thông báo!"
            text={responseDetailFormChangeTreament}
            onConfirmDialogClose={() => {
              handleClosePopupCofirmTrement(null);
              pagingRegisterTreatmentPlan();
            }}
            cancel="Đóng"
            open={!!openPopupComfirms}
          />
        )}
      </div>
    </section>
  );
};

export default memo(observer(RegisterTreatmentPlanIndex));
